import { createPinia, type Pinia } from 'pinia'

export const pinia: Pinia = createPinia()
